import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Label } from '../label';

const meta = {
  argTypes: {
    required: { table: { disable: true } },
    tooltip: { table: { disable: true } },
    weight: { table: { disable: true } },
  },
  args: {
    required: false,
    tooltip: '',
    weight: '',
  },
  decorators: [
    (story: PartialStoryFn, { args: { tooltip } }: StoryContext) => html`
      <style type="text/css">
        #root,
        .docs-story {
          padding: ${tooltip ? '2rem 0 0' : ''};
        }
      </style>
      ${story()}
    `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Label/',
};

interface Story {
  required: Label['required'];
  tooltip: Label['tooltip'];
  weight: Label['weight'];
}

const story = ({ required, tooltip, weight }: Partial<Story>) => html`
  <abds-label
    required="${ifDefined(required || undefined)}"
    tooltip="${ifDefined(tooltip || undefined)}"
    weight="${ifDefined(weight || undefined)}"
  >
    My Label
  </abds-label>
`;

export { meta, story };
